import { useTranslation } from "react-i18next";

const LANGS = [
    { code: "es", label: "ES" },
    { code: "en", label: "EN" },
    { code: "it", label: "IT" },
];

export default function LanguageSwitcher({ variant = "footer" }) {
    const { i18n, t } = useTranslation();
    const current = (i18n.resolvedLanguage || i18n.language || "es").slice(0, 2);
    const change = (code) => {
        i18n.changeLanguage(code);
        try {
            document.documentElement.setAttribute("lang", code);
        } catch (_) {}
    };

    const palette = variant === "footer"
        ? { idle: "text-[#A4A19A]", active: "text-[#8B6914]", label: "text-[#666666]" }
        : { idle: "text-[#666666]", active: "text-[#8B6914]", label: "text-[#666666]" };

    return (
        <div
            data-testid="language-switcher"
            className="flex items-center gap-3 text-xs tracking-[0.18em] uppercase"
        >
            <span className={`${palette.label}`}>{t("footer.language")}</span>
            <div className="flex items-center gap-2">
                {LANGS.map((l, i) => {
                    const isActive = current === l.code;
                    return (
                        <span key={l.code} className="flex items-center gap-2">
                            {i > 0 && <span className="text-[#3a3a3a]">·</span>}
                            <button
                                type="button"
                                data-testid={`lang-btn-${l.code}`}
                                onClick={() => change(l.code)}
                                className={`${isActive ? palette.active : palette.idle} hover:text-[#8B6914] transition-colors`}
                                aria-pressed={isActive}
                            >
                                {l.label}
                            </button>
                        </span>
                    );
                })}
            </div>
        </div>
    );
}
